import Vue from 'vue'
import Router from 'vue-router'
import DemoEcs from './demos/ecs/index.vue'
import DemoHelloWorld from './demos/hello-world/index.vue'
import DemoBasicKeyboardInput from './demos/basic-keyboard-input/index.vue'
import DemoAdvancedKeyboardInput from './demos/advanced-keyboard-input/index.vue'
import DemoCollision from './demos/collision/index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: DemoHelloWorld
    },
    {
      path: '/ecs',
      name: 'ecs',
      component: DemoEcs
    },
    {
      path: '/basic-keyboard-input',
      name: 'basicKeyboardInput',
      component: DemoBasicKeyboardInput
    },
    {
      path: '/advanced-keyboard-input',
      name: 'advancedKeyboardInput',
      component: DemoAdvancedKeyboardInput
    },
    {
      path: '/collision',
      name: 'collision',
      component: DemoCollision
    }
  ]
})
